import { createElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initialize } from 'redux-form';
import { FinancialDocumentPdfTemplateType } from '@mews-commander/data-access';
import { getCurrentEnterpriseDefaultLanguageCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { openDialog } from '../../../../../modules/dialog/reducer';
import { PrintAction } from './types';

interface ActionProps {
    action: PrintAction;
    component: React.ElementType;
    showPrintReasonDialog: boolean;
    setShowPrintReasonDialog: (showPrintReasonDialog: boolean) => void;
    firstUsedTemplateType: FinancialDocumentPdfTemplateType | null;
    setFirstUsedTemplateType: (firstUsedTemplateType: FinancialDocumentPdfTemplateType) => void;
}

export const PRINT_BILL_MODAL_NAME = 'printBillModal';
export const PRINT_BILL_PDF_INPUT_VALUE = 'pdf';

export const PrintFinancialDocumentAction = ({
    action,
    component,
    showPrintReasonDialog,
    setShowPrintReasonDialog,
    firstUsedTemplateType,
    setFirstUsedTemplateType,
}: ActionProps) => {
    const dispatch = useDispatch();
    const ownerLanguage = useSelector(getCurrentEnterpriseDefaultLanguageCode);

    const onClick = () => {
        dispatch(openDialog(PRINT_BILL_MODAL_NAME));
        dispatch(
            initialize(PRINT_BILL_MODAL_NAME, {
                action,
                showPrintReasonDialog,
                setShowPrintReasonDialog,
                firstUsedTemplateType,
                setFirstUsedTemplateType,
                language: ownerLanguage,
                printer: PRINT_BILL_PDF_INPUT_VALUE,
                template: FinancialDocumentPdfTemplateType.Detailed,
            })
        );
    };

    return createElement(component, {
        title: action.text,
        icon: action.icon,
        onClick,
    });
};
